// SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
// Copyright (C) 2023-2024 (original work) Open Assessment Technologies SA ;
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License

import config from '@/config';
import { getPermissionsGuard } from '@/core/guards/permissionsGuard';

export const routing = [
    {
        path: [config.routes.sessions.list],
        guard: getPermissionsGuard([
            { resource: 'portal.session', scopes: ['view'] },
            { resource: 'portal.session', scopes: ['list'] },
            { resource: 'portal.public-session', scopes: ['view'] }
        ]),
        controller: () => import('./controllers/sessions')
    },
    {
        path: [config.routes.sessions.monitoring],
        guard: getPermissionsGuard([
            { resource: 'portal.session', scopes: ['view'] },
            { resource: 'portal.public-session', scopes: ['view'] }
        ]),
        controller: () => import('./controllers/sessionMonitoring')
    },
    {
        path: [config.routes.sessions.overview],
        guard: getPermissionsGuard([
            { resource: 'portal.session', scopes: ['view'] },
            { resource: 'portal.public-session', scopes: ['view'] },
            { resource: 'portal.paperbased-session', scopes: ['view'] }
        ]),
        controller: () => import('./controllers/sessionOverview')
    },
    {
        path: [config.routes.sessions.sessionDetails],
        guard: getPermissionsGuard([
            { resource: 'portal.group', scopes: ['view'] },
            { resource: 'portal.session', scopes: ['view'] },
            { resource: 'portal.review-session', scopes: ['view', 'edit'] },
            { resource: 'portal.organization', scopes: ['view', 'edit'] },
            { resource: 'portal.public-session', scopes: ['view'] }
        ]),
        controller: () => import('./controllers/sessionDetails')
    },
    {
        path: [config.routes.sessions.sessionEnrollCandidate],
        controller: () => import('./controllers/sessionEnrollCandidate')
    },
    {
        path: [config.routes.sessions.sessionRoomManagement],
        guard: getPermissionsGuard([{ resource: 'portal.session-room', scopes: ['create'] }])
    },
    {
        path: [config.routes.sessions.sessionMoveCandidate],
        controller: () => import('./controllers/moveCandidate')
    },
    {
        path: [config.routes.sessions.edit],
        guard: getPermissionsGuard([
            { resource: 'portal.session', scopes: ['edit'] },
            { resource: 'portal.public-session', scopes: ['edit'] }
        ]),
        controller: () => import('./controllers/session')
    },
    {
        path: [config.routes.sessions.create],
        guard: getPermissionsGuard([
            { resource: 'portal.session', scopes: ['create'] },
            { resource: 'portal.public-session', scopes: ['create'] }
        ]),
        controller: () => import('./controllers/session')
    },
    {
        path: [config.routes.sessions.reports],
        controller: () => import('./controllers/sessionReports'),
        guard: getPermissionsGuard([{ resource: 'portal.session', scopes: ['edit'] }])
    },
    {
        path: [config.routes.sessions.certificationSessionsList],
        guard: getPermissionsGuard([{ resource: 'portal.session', scopes: ['view'] }]),
        controller: () => import('./controllers/certificationSessions')
    },
    {
        path: [config.routes.sessions.editSessionCluster],
        guard: getPermissionsGuard([
            { resource: 'portal.session-cluster', scopes: ['edit'] },
            { resource: 'portal.session-cluster', scopes: ['create'] },
            { resource: 'portal.campaign', scopes: ['view'] },
            { resource: 'portal.session-template', scopes: ['view'] }
        ]),
        controller: () => import('./controllers/sessionCluster')
    },
    {
        path: [config.routes.sessions.sessionClusterDetails],
        guard: getPermissionsGuard([
            { resource: 'portal.group', scopes: ['view'] },
            { resource: 'portal.session', scopes: ['view'] },
            { resource: 'portal.review-session', scopes: ['view', 'edit'] },
            { resource: 'portal.organization', scopes: ['view', 'edit'] },
            { resource: 'portal.public-session', scopes: ['view'] },
            { resource: 'portal.session-cluster', scopes: ['edit'] },
            { resource: 'portal.session-cluster', scopes: ['create'] }
        ]),
        controller: () => import('./controllers/sessionDetails')
    },
    {
        path: [config.routes.sessions.sessionClusterEditSession],
        guard: getPermissionsGuard([
            { resource: 'portal.group', scopes: ['view'] },
            { resource: 'portal.session', scopes: ['view'] },
            { resource: 'portal.review-session', scopes: ['view', 'edit'] },
            { resource: 'portal.organization', scopes: ['view', 'edit'] },
            { resource: 'portal.public-session', scopes: ['view'] },
            { resource: 'portal.session-cluster', scopes: ['edit'] },
            { resource: 'portal.session-cluster', scopes: ['create'] }
        ]),
        controller: () => import('./controllers/session')
    }
];
